<template>
    <div :id="`answer-module-${attach.id}`">
        <template v-if="!attach.data.answerType || attach.data.answerType === 'question'">

            <img
                v-if="attach.myAnswer && attach.data.answers && attach.data.answers[attach.myAnswer.choiceInt] && attach.data.answers[attach.myAnswer.choiceInt].imageUrl"
                :src="attach.data.answers[attach.myAnswer.choiceInt].imageUrl"
                :key="`attach-img-${attach.id}-${attach.myAnswer.choiceInt}`"
                :style="attach.data.imageWidth ? `max-width: ${attach.data.imageWidth}` : ''"
                class="slideImg"
            >

            <div
                v-if="!attach.myAnswer"
                :class="`html padded ${slide.type}`"
                :key="`attach-text-${attach.id}`"
                v-html="attach.data.noAnswer"
            />
            <div
                v-else-if="attach.myAnswer && attach.data.answers && attach.data.answers[attach.myAnswer.choiceInt]"
                :class="`html padded ${slide.type}`"
                :key="`attach-text-${attach.id}-${attach.myAnswer.choiceInt}`"
                v-html="attach.data.answers[attach.myAnswer.choiceInt].title"
            />
        </template>
        <template v-else-if="attach.data.answerType === 'wordcloud' && !attach.myAnswer.choiceText">
            <br :key="`w2k-${attach.id}`">
            <!-- This is not really needed, was just here to debug an edge case really -->
            <p
                :key="`w4k-${attach.id}`"
                style="text-align: center"
            >
                <f7-button
                    :key="`w3k-${attach.id}`"
                    red
                    @click="getAttachment(attach);"
                >Show my answers!</f7-button>
            </p>
            <br :key="`w7k-${attach.id}`">
        </template>
        <template v-else-if="attach.data.answerType === 'wordcloud' && attach.myAnswer.choiceText">
            <br :key="`w1k-${attach.id}`">
            <span
                v-for="(word, wi) in attach.myAnswer.choiceText"
                :key="`wk-${attach.id}-${wi}`"
                class="wordcloud"
            >{{ word }}</span>
        </template>
        <template v-else-if="attach.data.answerType === 'largestTrait' && attach.myAnswer.choiceText">
            <div
                :class="`html padded ${slide.type}`"
                :key="`attach-text-${attach.id}-${traitsChanged}`"
                v-html="renderLargestValueTraitBasedAnswer(attach.data.answerValueDelimiters, attach.data.answers, traitsChanged)"
            />
        </template>
        <template v-else>
            <div
                v-if="isNaN(parseFloat(attach.data.answerTraitGroup))"
                :class="`html padded ${slide.type}`"
                :key="`attach-text-${attach.id}-${traitsChanged}`"
                v-html="renderTraitBasedAnswer(attach.data.answerTraitGroup, attach.data.answers, traitsChanged)"
            />
            <div
                v-else
                :class="`html padded ${slide.type}`"
                :key="`attach-text-${attach.id}-${traitsChanged}`"
                v-html="renderValueTraitBasedAnswer(parseFloat(attach.data.answerTraitGroup), attach.data.answerValueDelimiters, attach.data.answers, traitsChanged)"
            />
        </template>
    </div>
</template>

<script>
export default {
    props: ['attach', 'slide'],
    store: ['api', 'user', 'traits', 'myTraits', 'myValueTraits'],
    data () {
        return {
            traitsChanged: 0,
        };
    },
    watch: {},
    mounted: function () {
        this.$events.on('userUpdateTraits', () => {
            this.traitsChanged++;
        });
    },

    methods: {
        // This is not really needed, was just here to debug an edge case really
        getAttachment: function (attach) {
            this.$http.get(`${this.api}/attachments/${attach.id}`).then(
                response => {
                    Vue.set(attach, 'myAnswer', response.body.myAnswer);
                },
                () => {

                }
            );
        },
        renderLargestValueTraitBasedAnswer: function (traitId, delimiters, answers) {
            console.log('largestTrait', delimiters)
            let largestValue = 0;
            let largestTraitId = 0;
            let largestIndex = 0;
            delimiters = delimiters.split(',');
            for (let i = 0; i < delimiters.length - 1; i++) {
                const traitId = parseFloat(delimiters[i]);
                const value = this.myValueTraits[traitId];
                if (value > largestValue) {
                    largestTraitId = traitId;
                    largestValue = value;
                }
            }
            if (largestTraitId) {
                let img = '';
                if (answers[largestIndex].imageUrl) {
                    img = `<img src="${answers[largestIndex].imageUrl}" class="slideImg"><br>`;
                }
                return img + answers[largestIndex].title.replace('{{value}}', largestValue);
            }
            return '';
        },
        renderValueTraitBasedAnswer: function (traitId, delimiters, answers) {
            console.log('VTrait', traitId, this.myValueTraits[traitId])
            if (!this.myValueTraits || !this.myValueTraits[traitId]) return console.log('Unanswerd')
            let val = this.myValueTraits[traitId];
            delimiters = delimiters.split(',');
            for (let i = 0; i < delimiters.length - 1; i++) {
                const minBound = parseFloat(delimiters[i]);
                const maxBound = parseFloat(delimiters[i + 1]);
                if (val >= minBound && val <= maxBound) {
                    let img = '';
                    if (answers[i].imageUrl) {
                        img = `<img src="${answers[i].imageUrl}" class="slideImg"><br>`;
                    }
                    return img + answers[i].title.replace('{{value}}', val);
                }
            }
            return '';
        },
        renderTraitBasedAnswer: function (groupName, answers) {
            let indexInGroup = 0;
            for (let i = 0; i < this.traits.length; i++) {
                const trait = this.traits[i];
                if (trait.groupName === groupName) {
                    if (this.myTraits.indexOf(trait.id) > -1) {
                        let img = '';
                        if (answers[indexInGroup].imageUrl) {
                            img = `<img src="${answers[indexInGroup].imageUrl}" class="slideImg"><br>`;
                        }
                        return img + answers[indexInGroup].title.replace('{{value}}', trait.displayName);
                    }
                    indexInGroup++;
                }
            }
            return '';
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.slideImg {
    width: 100%;
    max-width: 300px;
    margin: 20px auto 0;
}
</style>
